import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
} from "../recoil-atom"

import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"

import LinkMark from "./LinkMark"
import LinkMarkDrop from "./LinkMarkDrop"
import LinkMarkEdit from "./LinkMarkEdit"
import { emptyMark } from "../initdata"

import styled, { css } from "styled-components"
const Group = styled.div`
  overflow: hidden;
  padding: 0px 5px;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  min-width: 360px;
  display: grid;
  grid-template-columns: repeat(${(props) => props.repeatPage}, 1fr);
  justify-items: center;
  align-items: start;
`

const LinkGroup = ({ pageId, groupId }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)

  if (editMode) {
    return (
      <>
        <DndProvider backend={HTML5Backend}>
          <Group width={size.pageWidth} repeatPage={size.pageItem}>
            {updatedPagesObj[pageId][groupId].map((mark, index) => (
              <LinkMarkDrop
                pageId={pageId}
                groupId={groupId}
                markId={index}
                mark={mark}
                key={index}
              />
            ))}
            {updatedPagesObj[pageId][groupId].length < 12 ? (
              <LinkMarkEdit
                pageId={pageId}
                groupId={groupId}
                markId={updatedPagesObj[pageId][groupId].length}
                mark={emptyMark}
                key={updatedPagesObj[pageId][groupId].length}
              />
            ) : null}
          </Group>
        </DndProvider>
      </>
    )
  } else {
    return (
      <>
        <Group width={size.pageWidth} repeatPage={size.pageItem}>
          {updatedPagesObj[pageId][groupId].map((mark, index) => (
            <LinkMark
              pageId={pageId}
              groupId={groupId}
              markId={index}
              mark={mark}
              key={index}
            />
          ))}
        </Group>
      </>
    )
  }
}

export default LinkGroup
